import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getArticleOptions } from '@/module/Author/Article';
import { ArticleEdit } from '@/module/Author/Article/ArticleEdit';

export const Route = createFileRoute('/_auth/author/_author/article/_article/$articleId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { articleId } = Route.useParams();
  const { data: article } = useSuspenseQuery(getArticleOptions(articleId));

  return <ArticleEdit article={article} />;
}
